import React, { Component } from 'react';
import '../../scss/ErrorMessage.scss';

export default class ErrorMessage extends Component {
  render() {
    let locationList;
    let { message, locations } = this.props.error;
    
    if (locations) {
      locationList = (
        <ul>
          {locations.map((location, i) => {
            let { address } = location;
            return (
              <li className="ErrorMessage__item" key={i}>
                <button onClick={() => this.props.onClick(location)} className="ErrorMessage__button">
                  {address}
                </button>
              </li>
            );
          })}
        </ul>
      );
    }
    return (
      <div className="ErrorMessage">
        <span className="ErrorMessage__text">{message}</span>
        {locationList}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/lib/ErrorMessage.js